import { alpha } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import { svgIconClasses } from "@mui/material/SvgIcon";
//
import { paper, menuItem } from "../../css";
// ----------------------------------------------------------------------
export function autocomplete(theme) {
    return {
        MuiAutocomplete: {
            defaultProps: {
                // popupIcon: <ChevronDown size={18} />,
                ChipProps: { size: "small", variant: "soft" },
            },
            styleOverrides: {
                root: {
                    [`& span.${autocompleteClasses.tag}`]: Object.assign(Object.assign({}, theme.typography.subtitle2), { height: 24, minWidth: 24, lineHeight: "24px", textAlign: "center", padding: theme.spacing(0, 0.75), color: theme.palette.text.secondary, borderRadius: theme.shape.borderRadius, backgroundColor: alpha(theme.palette.grey[500], 0.16) }),
                    [`& .${autocompleteClasses.tag} .MuiChip-label`]: {
                        maxWidth: "155px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                    },
                    [`& .MuiAutocomplete-inputRoot .MuiAutocomplete-input`]: {
                        width: 0,
                        minWidth: "0px",
                    },
                },
                paper: Object.assign({}, paper({ theme, dropdown: true })),
                listbox: {
                    padding: 0,
                    [`& .${autocompleteClasses.option}`]: Object.assign({}, menuItem(theme)),
                },
                endAdornment: {
                    [`& .${svgIconClasses.root}`]: {
                        width: 18,
                        height: 18,
                    },
                },
            },
        },
    };
}
